<template>
  <!-- 修改日期格式弹窗 -->
  <custom-dialog :title="model.title" width="600px" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" :rules="rules" :validate-on-rule-change="false">
        <el-form-item key="timeZoneId" :label="$t('change_date_dialog.mo_ren_shi_qu')" prop="timeZoneId">
          <custom-select v-model="form.timeZoneId" url="timeZoneGetCompanyList" :clearable="false" width="100%" :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"></custom-select>
        </el-form-item>
         <el-form-item key="dateFormat" :label="$t('change_date_dialog.rqxsgs')" prop="dateFormat">
          <custom-select v-model="form.dateFormat" code="bas_date_format" width="100%"></custom-select>
        </el-form-item>
        <el-form-item key="isTime24h" :label="$t('change_date_dialog.24xiao_shi_zhi')" prop="isTime24h">
          <custom-select v-model="form.isTime24h" code="isynergy_cloud_bool" width="100%"></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        timeZoneId: '',
        dateFormat: '',
        isTime24h: '',
      }
    };
  },
  computed: {
    rules() {
      return {
        timeZoneId: [{ required: true, message: this.$t('change_date_dialog.qxzmrsq') }],
        dateFormat: [{ required: true, message: this.$t('change_date_dialog.qxzrqxsgs') }],
      };
    }
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.$getJSON(`${apis.User}/${this.userInfo.userId}`).then((res) => {
          this.$setFormatData(this.form, res.data);
        });
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UserUpdate, {
          userId: this.userInfo.userId,
          timeZoneId: this.form.timeZoneId,
          dateFormat: this.form.dateFormat,
          isTime24h: this.form.isTime24h,
        })
          .then(() => {
            this.visible = false;
            this.$store.commit('TIMEZONEID', this.form.timeZoneId);
            this.$store.commit('DATEFORMAT', this.form.dateFormat);
            this.$store.commit('ISTIME24H', this.form.isTime24h);
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
